import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { LoadPools } from '@/store/pools/actions';

import { CampaignName } from './components/CampaignName';
import { Tracking } from './components/Tracking';
import { Sending } from './components/Sending';
import { ScheduleCampaign } from './components/ScheduleCampaign';

export const SettingsAndTracking = (): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(LoadPools());
    }, []);

    return (
        <>
            <CampaignName />
            <ScheduleCampaign />
            <Sending />
            <Tracking />
        </>
    );
};
